import type { PropsWithChildren } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface FieldContainerProps {
  className?: string;
  dataTestId?: string;
  withoutBorder?: boolean;
}

export const FieldContainer = ({
  children,
  className,
  dataTestId,
  withoutBorder,
}: PropsWithChildren<FieldContainerProps>) => (
  <div
    className={classNames(
      "border-dark flex flex-col gap-y-3 rounded-lg border p-3",
      className,
      {
        "border-0": withoutBorder,
      },
    )}
    data-testid={dataTestId || undefined}
  >
    {children}
  </div>
);
